import { Button, CurrencyInput, Dialog } from '@wonderschool/common-base-ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BillingIntervalEnum } from '../../enums';

type EditProrateAmountModalProps = {
  amount: number;
  billingInterval: string;
  enrollmentDate: string;
  isOpen: boolean;
  onClose: () => void;
  onSave: (amount) => void;
};

const EditProrateAmountModal = ({
  amount,
  billingInterval,
  enrollmentDate,
  isOpen,
  onClose,
  onSave,
}: EditProrateAmountModalProps) => {
  const { t } = useTranslation();
  const [fixedAmount, setFixedAmount] = useState<number>(amount);

  useEffect(() => {
    setFixedAmount(amount);
  }, [amount]);

  const handleClose = () => {
    onClose();
  };

  const handleSave = () => {
    onSave(fixedAmount);
  };

  const handleAmountChange = ({ target }) => {
    const value = target.value.replace(',', '');
    if (value) {
      setFixedAmount(parseFloat(value));
    }
  };

  const getIntervalText = () => {
    switch (billingInterval) {
      case BillingIntervalEnum.WEEKLY:
        return t('enrollments.billingPeriod.week');
      case BillingIntervalEnum.BIWEEKLY:
        return t('enrollments.billingPeriod.biweek');
      case BillingIntervalEnum.MONTHLY:
        return t('enrollments.billingPeriod.month');
    }
    return '';
  };

  return (
    <Dialog isOpen={isOpen} onClose={handleClose} hasCloseButton>
      <Dialog.Title>
        <h1 className="border-b-2 border-b-gray-200 px-6 py-5 text-xl" data-testid="upload-admin-doc-title">
          {t('enrollments.editProrateAmount.header')}
        </h1>
      </Dialog.Title>
      <Dialog.Panel>
        <div className="flex flex-col">
          <div className="py-3 text-sm text-gray-800">
            {t('enrollments.editProrateAmount.content', {
              period: getIntervalText(),
              date: enrollmentDate,
            })}
          </div>
          <div>
            <CurrencyInput label="Prorated amount" value={fixedAmount.toString()} onChange={handleAmountChange} />
          </div>
        </div>
        <div className="mb-4 mt-8 flex justify-center gap-6">
          <Button extraClasses="w-full p-3" btn-secondary onClick={handleClose}>
            {t('common.cancel')}
          </Button>
          <Button extraClasses="w-full p-3" primary onClick={handleSave}>
            {t('common.update')}
          </Button>
        </div>
      </Dialog.Panel>
    </Dialog>
  );
};

export default EditProrateAmountModal;
